// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/img/log-min.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".technicalWorks_root__ui80F {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: no-repeat url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-size: cover;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden; }\n\n.technicalWorks_main__fHQU1 {\n  padding: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 16px; }\n\n.technicalWorks_link__1lSPv {\n  text-decoration: underline;\n  color: blue;\n  cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"root": "technicalWorks_root__ui80F",
	"main": "technicalWorks_main__fHQU1",
	"link": "technicalWorks_link__1lSPv"
};
module.exports = exports;
